import { render, staticRenderFns } from "./EditGovernmentDialog.vue?vue&type=template&id=035ebc96&scoped=true&"
import script from "./EditGovernmentDialog.vue?vue&type=script&lang=js&"
export * from "./EditGovernmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ebc96",
  null
  
)

export default component.exports